<template>
    <div class="container">
        <div v-for="(header) in headers" :key="header" class="font-7 header">
            {{header}}
        </div>

        <div class="font-4 rowData">
            {{reward}} {{currencyName}}
        </div>
        <div class="multiplier">
            <Dropdown :options="multiplierOptions"
                      selected-display-text-field="value"
                      display-field="value"
                      :selected-id="promotionFactor"
                      maxListHeight="140"
                      unique-id="promotionFactor"
                      @dropdownSelectedItemChanged="changeMultiplierFactor"
            />
        </div>
        <div class="font-4 rowData">
            = {{specialReward}} {{currencyName}}
        </div>
    </div>
</template>

<script>
import Dropdown from 'components/dropdowns/Dropdown.vue';

const headers = [
    'Default',
    'Multiplier',
    'Special Reward'
];

const MAX_MULTIPLIER = 10;
const START = 1;
const multiplierOptions = Array.from(Array(MAX_MULTIPLIER).keys())
    .filter((x) => x >= START)
    .map((x) => [
        { id: x + 0.5, value: `x${x + 0.5}` },
        { id: x + 1, value: `x${x + 1}` }
    ]).flat();

export default {
    name: 'PlacementMultiplier',
    components: { Dropdown },
    props: {
        promotionFactor: {
            type: Number,
            required: true
        },
        reward: {
            type: Number,
            default: 1
        },
        currencyName: {
            type: String,
            default: 'Credits'
        }
    },
    data() {
        return {
            headers,
            multiplierOptions
        };
    },
    computed: {
        specialReward() {
            return this.reward * this.promotionFactor;
        }
    },
    methods: {
        changeMultiplierFactor({ id }) {
            this.$emit('changeMultiplierFactor', id);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    .container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .header {
        line-height: 17px;
        color: $light-900;

    }

    .rowData {
        color: $light-900;
        line-height: 32px;
    }

    .multiplier {
        padding-right: 20px;
    }
</style>
